import React, { useState, useEffect, useContext } from 'react'
import AdminContext from '../../../StateContext/Application'
import { True32 } from '../../../../../public/LoginImages/importimages'
const VendorBills = () => {
  const context = useContext(AdminContext)
  const { GetVendorBills } = context
  const [vendorbills, setVendorBills] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredBills, setFilteredBills] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const billsPerPage = 4; // Show 4 bills per page

  // Pagination logic
  const totalPages = Math.ceil(filteredBills.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills.slice(indexOfFirstBill, indexOfLastBill);
  const getVendorsbills = async () => {
    let data = await GetVendorBills()
    setVendorBills(data)
    setFilteredBills(data)
  }
  useEffect(() => {
    getVendorsbills()
  }, [])
  let vendorBillList = []
  if (vendorbills.length > 0) {
    vendorBillList = vendorbills
  }

  // Filter bills based on search term
  useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    // const filtered = vendorbills.filter(bill =>
    //   (bill.UniqueID || '').toString().toLowerCase().includes(lowerSearchTerm)
    // );
    const filtered = vendorbills.filter(bill =>
      Object.values(bill).some((val) =>
        (val || '').toString().toLowerCase().includes(lowerSearchTerm)
      )
    );
    setFilteredBills(filtered);
    setCurrentPage(1); // Reset to page 1 on search
  }, [searchTerm, vendorbills]);
  return (
    <div style={{ overflowX: "hidden", display: 'grid', justifyContent: 'center', padding: "20px 0px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "80vw", maxWidth: "1200px", marginBottom: "15px" }}>
        <h4 style={{ margin: "10px" }}>Vendor Bills</h4>
        <div>
          <input
            type="text"
            placeholder="Search"
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
            style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }}
          />
        </div>
      </div>
      <div style={{ display: "grid", justifyContent: "center", width: "80vw", maxWidth: "100%", }}>
        <div style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', display: 'flex', width: '75vw', overflowX: "auto", border: '1px solid #3b409e' }}>
          <table style={{ width: '100%', width: "100%", borderCollapse: "collapse", minWidth: "1200px", }}>
            <thead style={{ borderTop: 'none' }}>
              <tr style={{ color: 'white', border: 'none', overflow: 'hidden', height: '3.5rem' }}>
                <th style={{ padding: '8px' }}>Bill Number</th>
                <th style={{ padding: '8px' }}>Unique ID</th>
                <th style={{ padding: '8px' }}>Company Name</th>
                <th style={{ padding: '8px' }}>Total Amount</th>
                <th style={{ padding: '8px' }}>Type Of Amount</th>
                <th style={{ padding: '8px' }}>Bank Name</th>
                <th style={{ padding: '8px' }}>Bank IFSC Code</th>
                <th style={{ padding: '8px' }}>Bank Account Number</th>
                <th style={{ padding: '8px' }}>Bank Account Holder Name</th>
                <th style={{ padding: '8px' }}>Uploaded By</th>
                <th style={{ padding: '8px' }}>Uploaded On</th>
                <th style={{ padding: '8px' }}>General Manager Approval</th>
                <th style={{ padding: '8px' }}>GM Approval Date</th>
                <th style={{ padding: '8px' }}>Account Approval</th>
                <th style={{ padding: '8px' }}>Account Approval Date</th>
                <th style={{ padding: '8px' }}>Admin Approval</th>
                <th style={{ padding: '8px' }}>Admin Approval Date</th>
                <th style={{ padding: '8px' }}>Status</th>
              </tr>
            </thead>
            {currentBills.map((bill, index) => (
              <tr key={bill.UniqueID} style={{ borderBottom: "1px solid darkgray", backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#CFE4F1", textAlign: "center", }}>
                <td style={{ padding: '8px' }}>{bill.BillNumber}</td>
                <td>{bill.UniqueID}</td>
                <td>{bill.Vendor_Company_Name}</td>
                <td>{bill.TotalAmount}</td>
                <td>{bill.TypeOfAmount}</td>
                <td>{bill.Bank_Name}</td>
                <td>{bill.Bank_IFSC_Code}</td>
                <td>{bill.Bank_Account_Number}</td>
                <td>{bill.Bank_Account_Holder_Name}</td>
                <td>{bill.UploadedBy}</td>
                <td>{new Date(bill.UploadedOn).toLocaleString('en-GB', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                  hour12: false
                }).replace(',', '')}</td>
                <td><div style={{display:'flex',justifyContent:'start',gap:'5px',alignItems:'center'}}><img src={True32}style={{width:'13px',height:'14px'}}/>{bill.General_Manager_Approval}</div></td>
                <td>{bill.GM_Approval_Date === null ? "Pending" : new Date(bill.GM_Approval_Date).toLocaleString('en-GB', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                  hour12: false
                }).replace(',', '')}</td>
                <td><div style={{display:'flex',justifyContent:'start',gap:'5px',alignItems:'center'}}><img src={True32}style={{width:'13px',height:'14px'}}/>{bill.Account_Approval}</div></td>
                <td>{bill.Acnt_Approval_Date === null ? "Pending" : new Date(bill.Acnt_Approval_Date).toLocaleString('en-GB', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                  hour12: false
                }).replace(',', '')}</td>
                <td  style={{ padding: '8px' }}><div style={{display:'flex',justifyContent:'start',gap:'5px',alignItems:'center'}}><img src={True32}style={{width:'13px',height:'14px'}}/>{bill.Admin_Approval}</div></td>
                <td  style={{ padding: '8px' }}>{bill.Admin_Approval_Date === null ? "Pending" : new Date(bill.Admin_Approval_Date).toLocaleString('en-GB', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                  hour12: false
                }).replace(',', '')}</td>
                <td  style={{ padding: '8px' }}>{bill.Status}</td>
              </tr>
            ))}
          </table>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: ' 0px 10px 0px 10px', height: '3rem', alignItems: 'center' }}>
          <div>
            <p style={{ margin: '0px', color: 'black' }}>Showing {filteredBills?.length} of {vendorbills?.length} entries</p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {/* First Page Button */}
            <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
              style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}>
              &laquo;
            </button>
            {/* Previous Button */}
            <button
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
              style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
              &lt;
            </button>

            <button
              style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
            </button>
            {/* Next Button */}
            <button
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
              style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
              &gt;
            </button>
            {/* Last Page Button */}
            <button
              onClick={() => setCurrentPage(totalPages)}
              disabled={currentPage === totalPages}
              style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
              &raquo;
            </button>
          </div>

        </div>
      </div>
      <style>
        {`
              @media (max-width: 1200px) {
                table {
                  width: 95vw !important;
                }
                th, td {
                  padding: 5px !important;
                  font-size: 14px !important;
                }
              }
              
              @media (max-width: 768px) {
                table {
                  width: 100vw !important;
                }
                th, td {
                  padding: 4px !important;
                  font-size: 12px !important;
                }
                .pagination-info {
                  font-size: 14px !important;
                }
              }
              
              @media (max-width: 480px) {
                table {
                  width: 100vw !important;
                  display: block !important;
                  overflow-x: auto !important;
                  min-width: 1200px !important;
                }
                th, td {
                  padding: 3px !important;
                  font-size: 10px !important;
                  text-align: center !important;
                }
                .pagination-info {
                  font-size: 12px !important;
                }
              }
            `}
      </style>
    </div>

  )
}

export default VendorBills




